//                                                           //
//  Program: ResidentPayoutsReports.jsx                              //
//  Application: Report                                      //
//  Option: Property Reports Listing                         //
//  Developer: Jay Jani 		                                     //
//  Date: 2023-08-16                                         //
//                                                           //
/////////////////////////////////////////////////////////   ///

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Tab, Modal, InputGroup, Form } from "react-bootstrap";
import ReportSidebar from "../common/ReportSidebar";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import ReportService from "../../services/ReportService";
import Select from "react-select";
import UnitsService from "../../services/UnitsService";
import Moment from "moment";
import MultiImageService from "./../../services/MultiImageService";
import Alerts from "../common/Alerts";
import AllPropertyReportSidebar from "../common/AllPropertyReportSidebar";
// import it from "@mobiscroll/react/dist/src/i18n/it";

class GuestWavioTransfer extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.state = {
      create_payment_array: [],
      is_draft: false,
      is_pay_success: false,
      pay_amount_val: "",
      payout_date_val: new Date(),
      payAmountArray: [],
      errors: {},
      importModal: false,
      file_url: "",
      file_name: "",
      open: true,
      eventKey: "0",
      is_inactive: false,
      isSubmit: false,
      isSave: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      module_search: "",
      module_search_display: "",
      exportMesssage: "",
      exportFilePath: "",
      exportResult: "",
      alertType: "xlsx",
      is_search: 0,
      isSearch: global.isSearch,
      is_pay_out_modal: false,
      input: {},
      unitList: [],
      selectedUnitList: [],
      unitRentStatusList: [],
      selectedUnitRentStatusList: [],
      unit_rent_status_slug: "",
      unit_rent_status_label: "",
      sendData: [],
      selectAll: true,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      totalPayOutList: {},
      saveSendModel: false,
      saveModel: false,
      deleteRoleModal: false,
      slug: this.props.match.params.slug,
      property_slug: this.props.match.params.propertySlug
        ? this.props.match.params.propertySlug
        : this.props.match.params.outsidePropertySlug
        ? this.props.match.params.outsidePropertySlug
        : "",
      pathname: window.location.pathname,
      paymentMode: {},
      paymentDate: {},
      property_logo_url: sessionStorage.getItem("property_logo_url"),
      property_type: sessionStorage.getItem("property_type"),
      property_name: sessionStorage.getItem("property_name"),
      year_value: sessionStorage.getItem("year_value")
        ? sessionStorage.getItem("year_value")
        : "",
      records: [],
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: true,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      configPay: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "reservation_slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: true,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      newUnitList: [],
      extraButtons: [],
      columns: [
        {
          key: "pay_check",
          text: (
            <Form.Check
              type="checkbox"
              name="selectAll"
              className="all-checkbox"
              checked={this.getselectAll}
              onChange={(e) => this.changeHandlerSelectAll(e)}
            />
          ),
          className:
            "pay_check hand-cursor text-center td_clickable report_fst_td",
          cell: (record, i) => {
            let paidAmountName = "pay_check_" + record.reservation_slug;
            let paidAmountId = "pay_check_" + record.reservation_slug;
            let checked = record.checked;
            if (record.waiver_gross_fee != "") {
              return (
                <Form.Check
                  type="checkbox"
                  name={paidAmountName}
                  value=""
                  className={`pay-check check-pay-` + record.unit_slug}
                  id={paidAmountId}
                  checked={checked}
                  onChange={(e) =>
                    this.changeHandlerCheckBox(
                      e,
                      i,
                      record.reservation_slug,
                      record.total_nightly_rate,
                      record.total_stay_nights
                    )
                  }
                />
              );
            } else {
              return "";
            }
          },
        },
        {
          key: "listing_name",
          text: "Listing Name",
          className: "unit_number hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            if (
              record.checkout_date != "Total" &&
              record.checkout_date != "Final Total"
            )
              return record.listing_name;
          },
        },
        {
          key: "guest_name",
          text: "Guest Name",
          className: "resident_name hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.guest_name;
            }
          },
        },
        {
          key: "unit_name",
          text: "Unit",
          className: "unit_number hand-cursor text-center td_clickable",
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.unit_name;
            } else {
              return "";
            }
          },
        },
        {
          key: "Check In Date",
          text: "Check In",
          className: "checkin_date hand-cursor text-center td_clickable",
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.checkin_date;
            } else if (record.waiver_gross_fee == "") {
              return "TOTAL";
            } else {
              return "N/A";
            }
          },
        },
        {
          key: "Check Out Date",
          text: "Check Out",
          className: "checkout_date hand-cursor text-center td_clickable",
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.checkout_date;
            } else if (record.waiver_gross_fee == "") {
              return (
                <Form.Control
                  placeholder="Payment #"
                  type="text"
                  value={record.payment_reference}
                  name={`payment_ref_no_` + record.unit_resident_slug}
                  onChange={(e) =>
                    this.changeHandlerPaymentRef(e, record.unit_resident_slug)
                  }
                />
              );
            }
          },
        },
        {
          key: "Nights Booked",
          text: "No of Nights Booked",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          // changeHandlerPaymentDate
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.total_stay_nights;
            } else if (record.waiver_gross_fee == "") {
              return record.total_nights;
            } else {
              return "N/A";
            }
          },
        },
        {
          key: "waiver_gross_fee",
          text: "Waiver Gross Fee",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            if (record.waiver_gross_fee != "") {
              return record.waiver_gross_fee
                ? "$" + parseFloat(record.waiver_gross_fee)
                : 0;
            } else if (record.waiver_gross_fee == "") {
              return record.total_wavio_amount
                ? "$" + parseFloat(record.total_wavio_amount)
                : 0;
            } else {
              return "N/A";
            }
          },
        },
      ],
    };
    this.saveOrUpdatePayout = this.saveOrUpdatePayout.bind(this);
    this.draftPayoutStatus = this.draftPayoutStatus.bind(this);
    this.succssPayoutStatus = this.succssPayoutStatus.bind(this);
    this.changeHandlerPayoutAmount = this.changeHandlerPayoutAmount.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.removeTotalClass = this.removeTotalClass.bind(this);
    this.changeHandlerExtraAmount = this.changeHandlerExtraAmount.bind(this);
  }
  getselectAll = true;

  componentDidMount() {
    this.getPayOutReports();
    this.gerDefaultInOutDate();
  }

  changeHandlerPaymentMode = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.payment_mode = event.target.value;
        item.payment_method = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerExtraAmount = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.extra_amount = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPaymentDate11 = (event) => {
    let data = this.state.records;
    let unitResSlug = event.target.slug;
    if (event.target.type === "date" && event.target.value !== null) {
      data.forEach((item) => {
        let unit_res_slug = item.unit_resident_slug;
        if (unit_res_slug.startsWith(unitResSlug)) {
          item.payout_date = Moment(event.target.value).toDate();
        }
      });
    }
    this.setState({ records: data });
  };

  changeHandlerPaymentDate = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.payout_date = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPaymentRef = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.payment_reference = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPayNote = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.pay_note = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPaymentProof = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.payment_proof = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPaymentMemo = (event, unitResSlug) => {
    let data = this.state.records;
    data.forEach((item) => {
      let unit_res_slug = item.unit_resident_slug;
      if (unit_res_slug.startsWith(unitResSlug)) {
        item.memo = event.target.value;
      }
    });
    this.setState({ records: data });
  };

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    value = event.target.type === "radio" ? parseInt(value) : value;

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });

    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();

    this.setState({ confirm_back: 1 });
  };

  openSaveModal(slug) {
    this.setState({ saveModel: true });
  }

  closeSaveModal() {
    this.setState({ saveModel: false });
  }

  openSaveSendModal(slug) {
    this.setState({ saveSendModel: true });
  }

  closeSaveSendModal() {
    this.setState({ saveSendModel: false });
  }

  async clearFilter() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.setState({ is_search: 0 });
    this.setState({
      checkout_date_from: firstDay,
      checkout_date_to: lastDay,
      unit_slug: "",
      selectedUnitList: [],
      unitRentStatusList: [],
      selectedUnitRentStatusList: [],
      unit_rent_status_slug: "",
      unit_rent_status_label: "",
    });
    this.setState({ module_search: "" });
    await this.removeTotalClass();
    this.getPayOutReports();
  }

  saveOrUpdatePayout = async (e) => {
    e.preventDefault();
    var selectedRecords = [];
    var fileName = "";
    var filePath = "";
    this.setState({ showSpinner: true });
    let res = "";
    if (this.state.records.length > 0) {
      selectedRecords = this.state.records.filter(
        (item) => item.checked === true
      );
    }
    let inputData = {
      property_slug: this.state.property_slug
        ? this.state.property_slug
        : this.props.property_slug,
      waiver_start_date: this.state.checkout_date_from
        ? Moment(this.state.checkout_date_from).format("MM/DD/YY")
        : "",
      waiver_end_date: this.state.checkout_date_to
        ? Moment(this.state.checkout_date_to).format("MM/DD/YY")
        : "",
      waiverData: selectedRecords,
    };

    res = await ReportService.createWavioPayout(inputData);
    this.setState({
      showSpinner: false,
      saveSendModel: false,
      saveModel: false,
    });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );

    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      if (res.data && res.data.length > 0) {
        fileName = res.data ? res.data.fileName : "";
        filePath = res.data ? res.data.filePath : "";
        await this.getDownloadFile(filePath, fileName);
      }

      setTimeout(
        () =>
          this.props.history.push(
            this.props.match.params.propertySlug !== undefined
              ? "/properties/view/" +
                  this.state.property_slug +
                  "/wavio-transfer-fee-list"
              : "/wavio-transfer-fee-list"
          ),
        global.redirect_time
      );
    } else {
      let alertMessage = "";
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.message ? res.message : "Error!",
        alertModalMessage: alertMessage !== "" ? alertMessage : res.message,
      });
    }
  };

  draftPayoutStatus = async (e) => {
    this.setState({
      is_draft: true,
      is_pay_success: false,
    });
  };

  succssPayoutStatus = async (e) => {
    this.setState({
      is_pay_success: true,
      is_draft: false,
    });
  };

  async ExportData() {
    this.setState({ showSpinner: true, isSubmit: true, isSave: true });
    let data = {
      property_slug: this.state.property_slug,
    };

    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let queryString =
      "is_export=1" +
      "&file_type=" +
      this.state.alertType +
      "&checkout_date_from=" +
      checkOutFromDate +
      "&unit_slug=" +
      (this.state.unit_slug ? this.state.unit_slug : "") +
      "&checkout_date_to=" +
      checkOutDateTo;

    let res = await ReportService.exportPropertyPayOutReport(data, queryString);
    if (res.data.filePath) {
      this.getDownloadFile(res.data.filePath, res.data.fileName);
      this.setState({ exportMesssage: res.message });
      this.setState({ exportResult: data });
      this.setState({ exportFilePath: res.data.filePath });
    }
    this.setState({ showSpinner: false, isSubmit: false, isSave: false });
  }

  async getDownloadFile(url, name) {
    let file_name = name.split(".")[0];
    var queryString = "path=" + url + "&display_file_name=" + file_name;
    this.setState({ showSpinner: true, loading: true });
    let inputData = {
      // path: url,
    };
    var resData = {};
    await MultiImageService.downloadFile(inputData, queryString);
    this.setState(resData);
    this.setState({
      showSpinner: false,
      loading: false,
    });
  }

  exportToggle = () => {
    if (this.state.isModel === 1) {
      this.setState({ exportMesssage: "" });
      this.setState({ isModel: 0 });
      this.setState({ showSpinner: false, isSubmit: false, isSave: false });
    } else {
      this.setState({ isModel: 1 });
    }
  };

  gerDefaultInOutDate() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.setState({ checkout_date_from: firstDay });
    this.setState({ checkout_date_to: lastDay });
  }

  changeExport(evt) {
    let value = evt.target.value;
    this.setState({ alertType: value });
  }

  async showPayoutReport(unitSlug) {
    this.setState({ showSpinner: true, loading: true });
    var listPay = [];
    var totalRecordsPay = 0;
    let payoutDetailsTitle;
    let data = {
      property_slug: this.state.property_slug,
    };
    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let queryString =
      "unit_slug=" +
      unitSlug +
      "&checkout_date_from=" +
      checkOutFromDate +
      "&checkout_date_to=" +
      checkOutDateTo;
    let res = await ReportService.showPayOutReport(data, queryString);
    if (global.successStatus.includes(res.status)) {
      listPay = res.data.data ? res.data.data : [];
      totalRecordsPay = res.data.data.length ? res.data.data.length : 0;
      payoutDetailsTitle = res.data.data.length
        ? res.data.data[0].aka_name + "-" + res.data.data[0].unit_number
        : "Pay Out Report";
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record_pay: totalRecordsPay,
      record_pay: listPay,
      payoutDetailsTitle: payoutDetailsTitle,
    });
    this.payoutDataModalToggle();
  }

  payoutDataModalToggle = () => {
    if (this.state.is_pay_out_modal === 1) {
      this.setState({ is_pay_out_modal: 0 });
    } else {
      this.setState({ is_pay_out_modal: 1 });
    }
  };

  getPayOutReports = async (queryString = "") => {
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var slug_query = "";
    var totalRecords = 0;
    var res = "";
    res = await ReportService.geWavioPayOutReportsCreate(
      this.state.property_slug,
      queryString + slug_query
    );

    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
      totalRecords = list ? list.length : 0;
      var paymentDataArray = [];
      if (totalRecords > 0) {
        res.data.forEach((item, i) => {
          paymentDataArray.push({
            unit_slug: item.unit_slug,
            unit_resident_slug: item.unit_resident_slug,
            reservation_slug: item.reservation_slug,
            payout_amount: item.waiver_gross_fee,
          });
        });
      }
    }

    if (totalRecords > 0) {
      list.forEach((item, i) => {
        if (item.checkout_date !== "Note") {
          item.checked = true;
          item.payment_mode = item.payment_method ? item.payment_method : "";
          item.payment_method = item.payment_method ? item.payment_method : "";
          item.memo = item.memo ? item.memo : "";
          item.payment_reference = item.payment_reference
            ? item.payment_reference
            : "";
          item.pay_note = item.pay_note ? item.pay_note : "";
          item.extra_amount = item.extra_amount ? item.extra_amount : "";
          item.payout_date = item.payout_date ? item.payout_date : "";
          item.payment_proof = item.payment_proof ? item.payment_proof : "";
          item.pays = item.property_earning ? item.property_earning : "";
        }
      });
    }

    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      records: list,
      sendData: res.data,
      //sendData:paymentDataArray
    });
    this.addTotalClass();
  };

  /** Add Class on page load */
  addTotalClass = async () => {
    const child = document.getElementsByClassName("to-pay1");
    let childNo = child.length;
    for (let i = 0; i < childNo; i++) {
      let ele = child[i].parentElement.parentElement;
      ele.classList.add("to_total");
    }
    const childDiff = document.getElementsByClassName("diff-line1");
    let childNoDiff = childDiff.length;
    for (let i = 0; i < childNoDiff; i++) {
      let ele = childDiff[i].parentElement.parentElement;
      if (ele) {
        ele.classList.add("to_diff");
      }
    }
    const childFut = document.getElementsByClassName("future-row1");
    let childNoFut = childFut.length;
    for (let i = 0; i < childNoFut; i++) {
      let ele = childFut[i].parentElement.parentElement;
      if (ele) {
        ele.classList.add("to_future");
      }
    }
    if (document.getElementsByClassName("grand_total1").length > 0) {
      const grand_total = document.getElementsByClassName("grand_total1")[0];
      let ele1 = grand_total.parentElement.parentElement;
      ele1.classList.add("grand_total");
    }
    if (document.getElementsByClassName("future-grand1").length > 0) {
      const grand_total_fu =
        document.getElementsByClassName("future-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.add("grand_total_future");
    }
    if (document.getElementsByClassName("past-grand1").length > 0) {
      const grand_total_fu = document.getElementsByClassName("past-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.add("grand_total_past");
    }
  };

  removeTotalClass = async () => {
    const child = document.getElementsByClassName("to-pay1");
    let childNo = child.length;
    for (let i = 0; i < childNo; i++) {
      let ele = child[i].parentElement.parentElement;
      ele.classList.remove("to_total");
    }
    const childFut = document.getElementsByClassName("future-row1");
    let childNoFut = childFut.length;
    for (let i = 0; i < childNoFut; i++) {
      let ele = childFut[i].parentElement.parentElement;
      if (ele) {
        ele.classList.remove("to_future");
      }
    }
    const childDiff = document.getElementsByClassName("diff-line1");
    let childNoDiff = childDiff.length;
    for (let i = 0; i < childNoDiff; i++) {
      let ele = childDiff[i].parentElement.parentElement;
      if (ele) {
        ele.classList.remove("to_diff");
      }
    }
    if (document.getElementsByClassName("grand_total1").length > 0) {
      const grand_total = document.getElementsByClassName("grand_total1")[0];
      let ele1 = grand_total.parentElement.parentElement;
      ele1.classList.remove("grand_total");
    }
    if (document.getElementsByClassName("future-grand1").length > 0) {
      const grand_total_fu =
        document.getElementsByClassName("future-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.remove("grand_total_future");
    }
    if (document.getElementsByClassName("past-grand1").length > 0) {
      const grand_total_fu = document.getElementsByClassName("past-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.remove("grand_total_past");
    }
  };

  /* to get unit data list */
  async getUnitData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var unitList = [];
    var unitListTotal = 0;
    let res = await UnitsService.getUnitsList(
      "is_dropdown=1&property_slug=" +
        (this.state.property_slug ? this.state.property_slug : ""),
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      unitList = res.data ? res.data : [];
      unitListTotal = unitList ? unitList.length : 0;
    }
    const newUnitList =
      unitListTotal > 0
        ? unitList.map(({ slug, unit_name, tower, total_tower_count }) => ({
            value: slug,
            label: unit_name,
          }))
        : [];
    this.setState({
      unitList: unitList,
      unitListTotal: unitListTotal,
      newUnitList: newUnitList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
    }
  };

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.getUnitData();
      this.setState({ isSearch: 1 });
      const unitRentStatusList = [
        { value: "unpaid", label: "Unpaid" },
        { value: "paid", label: "Paid" },
      ];
      this.setState({ unitRentStatusList: unitRentStatusList });
    }
  };

  handleChangeUnitList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_slug_value = value !== null ? value.value : [];
    const selected_unit_number = value !== null ? value.label : [];
    this.setState({
      selectedUnitList: value,
      unit_slug: unit_slug_value,
      unit_lable: selected_unit_number,
    });
    this.setState({ confirm_back: 1 });
  }

  handleChangeUnitRentStatusList(value) {
    let unit_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
      });
    }
    const unit_rent_slug_value = value !== null ? value.value : [];
    const selected_unit_label = value !== null ? value.label : [];
    this.setState({
      selectedUnitRentStatusList: value,
      unit_rent_status_slug: unit_rent_slug_value,
      unit_rent_status_label: selected_unit_label,
    });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  changeHandlerSelectAll = async (event) => {
    //Use for Selection Check Box checked or Un checked in all listing
    var list = this.state.records;
    var total_pays = 0;
    var total_night = 0;
    if (event.target.checked === true) {
      list.forEach((item, i) => {
        item.checked = true;
      });
      list.forEach((item) => {
        if (item.reservation_slug !== "" && item.checked == true) {
          let stg_item_pays = parseFloat(item.total_nightly_rate);
          let stg_item_night = parseFloat(item.total_stay_nights);
          total_pays += stg_item_pays;
          total_night += stg_item_night;
        }
      });
      list.forEach((item) => {
        if (item.reservation_slug == "" && item.checked == true) {
          item.total_wavio_amount = total_pays;
          item.total_nights = total_night;
        }
      });
      this.setState({ selectAll: true });
      this.setState({ records: list });
    } else {
      list.forEach((item, i) => {
        item.total_wavio_amount = 0;
        item.total_nights = 0;
        item.checked = false;
      });
      this.setState({ selectAll: false });
      this.setState({ records: list });
    }

    let newColumns = [];
    this.state.columns.forEach((item, i) => {
      let newitem = item;
      let mychecked = true;
      if (item.key === "pay_check") {
        if (event.target.checked === true) {
          mychecked = true;
        } else {
          mychecked = false;
        }
        newitem = {
          key: "pay_check",
          text: (
            <Form.Check
              type="checkbox"
              name="selectAll"
              className="all-checkbox"
              checked={mychecked}
              onChange={(e) => this.changeHandlerSelectAll(e)}
            />
          ),
          className: "pay_check hand-cursor text-center td_clickable",
          cell: (record, i) => {
            let paidAmountName = "pay_check_" + record.reservation_slug;
            let paidAmountId = "pay_check_" + record.reservation_slug;
            let checked = record.checked;
            if (["Note"].includes(record.checkout_date)) {
              return "";
            } else if (["Total"].includes(record.checkout_date)) {
              return "";
            }
            if (record.waiver_gross_fee != "") {
              return (
                <Form.Check
                  type="checkbox"
                  name={paidAmountName}
                  value=""
                  className={`pay-check check-pay-` + record.unit_slug}
                  id={paidAmountId}
                  checked={checked}
                  onChange={(e) =>
                    this.changeHandlerCheckBox(
                      e,
                      i,
                      record.reservation_slug,
                      record.total_nightly_rate,
                      record.total_stay_nights
                    )
                  }
                />
              );
            }
          },
        };
      }
      newColumns.push(newitem);
    });
    this.setState({ columns: newColumns });
  };

  changeHandlerCheckBox = async (
    event,
    index,
    reservation_slug,
    total_nightly_rate,
    total_stay_nights
  ) => {
    let data = this.state.records;
    data.forEach((item) => {
      if (item.reservation_slug === reservation_slug) {
        item.checked ? (item.checked = false) : (item.checked = true);
      }
      if (item.reservation_slug == "") {
        item.checked = true;
      }
    });

    var allCheck = data.some((items) => {
      return items.checked === false;
    });
    if (allCheck) {
      this.setState({ selectAll: false });
    } else {
      this.setState({ selectAll: true });
    }

    let newColumns = [];
    this.state.columns.forEach((item, i) => {
      let newitem = item;
      let mychecked = true;
      if (item.key === "pay_check") {
        if (allCheck === true) {
          mychecked = false;
        } else {
          mychecked = true;
        }
        newitem = {
          key: "pay_check",
          text: (
            <Form.Check
              type="checkbox"
              name="selectAll"
              className="all-checkbox"
              checked={mychecked}
              onChange={(e) => this.changeHandlerSelectAll(e)}
            />
          ),
          className: "pay_check hand-cursor text-center td_clickable",
          cell: (record, i) => {
            let paidAmountName = "pay_check_" + record.reservation_slug;
            let paidAmountId = "pay_check_" + record.reservation_slug;
            let checked = record.checked;
            if (["Note"].includes(record.checkout_date)) {
              return "";
            } else if (["Total"].includes(record.checkout_date)) {
              return "";
            }
            if (record.waiver_gross_fee != "") {
              return (
                <Form.Check
                  type="checkbox"
                  name={paidAmountName}
                  value=""
                  className={`pay-check check-pay-` + record.unit_slug}
                  id={paidAmountId}
                  checked={checked}
                  onChange={(e) =>
                    this.changeHandlerCheckBox(
                      e,
                      i,
                      record.reservation_slug,
                      record.total_nightly_rate,
                      record.total_stay_nights
                    )
                  }
                />
              );
            }
          },
        };
      }
      newColumns.push(newitem);
    });
    this.setState({ columns: newColumns });

    let total_pays = 0;
    let total_night = 0;
    data.forEach((item) => {
      if (item.reservation_slug !== "" && item.checked == true) {
        let stg_item_pays = parseFloat(item.total_nightly_rate);
        let stg_item_night = parseFloat(item.total_stay_nights);
        total_pays += stg_item_pays;
        total_night += stg_item_night;
      }
    });
    data.forEach((item) => {
      if (item.reservation_slug == "" && item.checked == true) {
        item.total_wavio_amount = total_pays;
        item.total_nights = total_night;
      }
    });
    this.setState({ records: data });
  };

  changeHandlerPayoutAmount = async (
    event,
    index,
    reservation_slug,
    property_earning
  ) => {
    let payamountVal = event.target.value;
    let data = this.state.records;
    data.forEach((item) => {
      if (item.reservation_slug === reservation_slug) {
        item.pays = payamountVal;
      }
    });
    await this.setState({ records: data });
  };

  changeHandler = async (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    await this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  async filterData() {
    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let queryString =
      "&checkout_date_from=" +
      checkOutFromDate +
      "&unit_slug=" +
      (this.state.unit_slug ? this.state.unit_slug : "") +
      "&checkout_date_to=" +
      checkOutDateTo +
      "&is_rent_paid=" +
      (this.state.unit_rent_status_slug
        ? this.state.unit_rent_status_slug
        : "") +
      "&is_search=1";
    let moduleSearchString = "";
    let searchDisplay = "";
    moduleSearchString = this.state.checkout_date_from
      ? "check in date - " + this.state.checkout_date_from
      : "";
    moduleSearchString = this.state.unit_slug
      ? moduleSearchString
        ? moduleSearchString + " &" + " unit - " + this.state.unit_slug
        : " unit - " + this.state.unit_slug
      : moduleSearchString;
    searchDisplay =
      "Check In Date- " +
      Moment(checkOutFromDate).format("MM/DD/YY") +
      ", " +
      "Check Out Date- " +
      Moment(checkOutDateTo).format("MM/DD/YY");
    if (this.state.unit_lable) {
      searchDisplay = searchDisplay + ", Unit- " + this.state.unit_lable;
    }
    if (this.state.unit_rent_status_label) {
      searchDisplay =
        searchDisplay + ", Unit Rent - " + this.state.unit_rent_status_label;
    }
    if (
      this.state.checkout_date_from ||
      this.state.unit_slug ||
      this.state.checkout_date_to
    ) {
      this.setState({ customQueryString: queryString });
      this.searchToggle();
      this.setState({ is_search: 1 });
      this.setState({ module_search: moduleSearchString });
      this.setState({ module_search_display: searchDisplay });
      await this.removeTotalClass();
      this.getPayOutReports(queryString);
    }
  }

  /* table events */
  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getPayOutReports(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getPayOutReports(queryString);
    }
  };

  rowClickedHandlerPay = (event, data, rowIndex) => {
    if (data.unit_slug) {
      this.showPayoutReport(data.unit_slug);
    }
  };

  rowClickedHandler = (event, data, rowIndex) => {
    /* if (data.reservation_slug) {
          let route = "reservations/view/" + data.reservation_slug;
          window.open(route, "_blank");
        } */
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                {this.props.match.params.propertySlug !== undefined ? (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <ReportSidebar property_slug={this.state.property_slug} />
                    </div>
                  </div>
                ) : (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <AllPropertyReportSidebar
                        property_slug={this.state.property_slug}
                      />
                    </div>
                  </div>
                )}
                <div className="col-md-10 right">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      {this.state.slug === undefined ? (
                        <h3>Create Waiver Payout</h3>
                      ) : (
                        <h3>Draft Payout</h3>
                      )}
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {this.state.slug === undefined ? (
                          <button
                            className="btn-success-outline-small mr-3 button-width"
                            onClick={this.searchToggle}
                          >
                            Search
                          </button>
                        ) : (
                          ""
                        )}
                        <button
                          type="button"
                          className="btn-success-outline-small mr-3 button-width"
                          onClick={() => {
                            if (this.state.confirm_back === 1)
                              if (
                                window.confirm(
                                  "Do you want to exit without saving?"
                                )
                              )
                                this.props.history.push(
                                  this.props.match.params.propertySlug !==
                                    undefined
                                    ? "/properties/view/" +
                                        this.state.property_slug +
                                        "/reservations"
                                    : "/reservations"
                                );
                              else return false;
                            else
                              this.props.history.push(
                                this.props.match.params.propertySlug !==
                                  undefined
                                  ? "/properties/view/" +
                                      this.state.property_slug +
                                      "/wavio-transfer-fee-list"
                                  : "/wavio-transfer-fee-list"
                              );
                          }}
                        >
                          Cancel
                        </button>
                        {/* {this.state.slug === undefined ? (
                          <button
                            className="btn-success-outline-small mr-3 button-width"
                            onClick={(e) => this.openSaveModal()}
                            disabled={this.state.isSave ? true : false}
                          >
                            {this.state.saveModel
                              ? global.loader
                              : this.state.slug !== undefined
                              ? "Save"
                              : "Save"}
                          </button>
                        ) : (
                          ""
                        )} */}
                        <button
                          className="btn-success-outline-small mr-3 button-width"
                          onClick={(e) => this.openSaveSendModal()}
                          disabled={this.state.isSubmit ? true : false}
                        >
                          {this.state.saveSendModel
                            ? global.loader
                            : this.state.slug !== undefined
                            ? "Save & Send"
                            : "Save & Send"}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0 mg-t-15">
                    <Alerts
                      show={this.state.showAlertModal}
                      type={this.state.alertModalType}
                      title={this.state.alertModalTitle}
                      message={this.state.alertModalMessage}
                    />
                  </div>

                  {this.state.is_search === 1 ? (
                    <div className="col-md-12 pd-lg-l-45 pd-lg-r-45 mg-t-0 d-inline-flex align-items-center justify-content-between scrolling-carousel">
                      {"Search applied on: " + this.state.module_search_display}
                      <button
                        onClick={this.clearFilter}
                        className="mg-l-15 btn-success-outline-small"
                      >
                        Clear
                      </button>
                    </div>
                  ) : (
                    <div className="col-md-12 pd-lg-l-45 pd-md-l-45  pd-lg-r-45 pd-md-r-30   mg-t-0 d-inline-flex align-items-center justify-content-between">
                      {`Search applied on: Check In From Date -  ${Moment(
                        this.state.checkout_date_from
                      ).format("MM/DD/YY")} , Check In To Date - ${Moment(
                        this.state.checkout_date_to
                      ).format("MM/DD/YY")} `}
                    </div>
                  )}
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-lg-l-0 pd-lg-r-15 pd-xs-r-0">
                    <div className="scrolling-carousel pd-l-15 scroll-slide">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="all"
                        onSelect={(e) => this.getActiveClass(e)}
                        eventKey={this.state.activeClass}
                        className="pd-r-60"
                      >
                        <Tab.Content className="m-0">
                          <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                            <div className="mg-t-18 brandList pd-l-15 pd-r-15 payout-report-tbl- resident-payout-table earning-report-tbl gen-res-tbl">
                              <div className=" pd-lg-l-0 pd-xs-l-0">
                                <div className="scroll-report-table payout_tble_cust">
                                  <ReactDatatable
                                    className="table no-wrap mg-b-30 pd-b-2  brandtable border table_last_row report_fst_th"
                                    config={
                                      this.state.total_record > global.page_size
                                        ? this.state.config
                                        : this.state.config
                                    }
                                    records={this.state.records}
                                    columns={this.state.columns}
                                    extraButtons={this.state.extraButtons}
                                    dynamic={true}
                                    total_record={this.state.total_record}
                                    onChange={this.tableChangeHandler}
                                    onRowClicked={this.rowClickedHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Module search popup modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Search in Waiver Payout Report</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Check In From Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="checkout_date_from"
                    selected={this.state.checkout_date_from}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "checkout_date_from",
                          value: data,
                        },
                      })
                    }
                  />
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Unit</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedUnitList}
                      options={this.state.newUnitList}
                      onChange={(value) => this.handleChangeUnitList(value)}
                      defaultValue={this.state.selectedUnitList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Check In To Date</label>
                  <div className="col-md-12 p-0">
                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      disabledKeyboardNavigation
                      strictParsing
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="checkout_date_to"
                      selected={this.state.checkout_date_to}
                      dateFormat="MM/dd/yy"
                      onChange={(data) =>
                        this.changeHandler({
                          target: {
                            type: "date",
                            name: "checkout_date_to",
                            value: data,
                          },
                        })
                      }
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.filterData()}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        {/* Module Export  popup modal */}
        <Modal show={this.state.isModel} className="modal-xs" centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.exportToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Export</h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <InputGroup className="mt-0">
                  <label>Select Export File Type : </label>
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="xlsx"
                        checked={this.state.alertType === "xlsx" ? true : false}
                        type={"radio"}
                        id="xlsx"
                        label={"XLSX"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="csv"
                        checked={this.state.alertType === "csv" ? true : false}
                        type={"radio"}
                        id="csv"
                        label={"CSV"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="pdf"
                        checked={this.state.alertType === "pdf" ? true : false}
                        type={"radio"}
                        id="pdf"
                        label={"PDF"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                  </div>
                </InputGroup>

                {this.state.exportMesssage !== "" && (
                  <div>
                    {this.state.exportMesssage}
                    <br></br>
                    <br></br>
                    {/* {this.state.exportFilePath !== undefined && (
                      <a href={this.state.exportFilePath}> Download File </a>
                    )} */}
                  </div>
                )}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="mx-auto- mg-r-30 btn btn btn-success btn-block"
                    onClick={() => this.ExportData()}
                    disabled={this.state.isSubmit ? true : false}
                  >
                    {this.state.isSubmit ? global.loader : "Export"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block"
                    onClick={() => this.exportToggle()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* Module Pay Out Report Data */}
        <Modal
          show={this.state.is_pay_out_modal}
          className="modal-large searchModalbox"
          centered
          size="lg"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.payoutDataModalToggle()}
            >
              {global.closee}
            </span>
            <h3 className="text-center mb-0">
              {this.state.payoutDetailsTitle} Payout Detail
            </h3>
            <div className="row col-12 m-auto pd-lg-l-15 pd-lg-r-0 pd-xs-l-0 pd-xs-r-0">
              <div className="payout-report-tbl payout-details-tbl">
                <ReactDatatable
                  className="table no-wrap mg-b-30 pd-b-2 brandtable border table_last_row"
                  config={
                    this.state.total_record_pay > global.page_size
                      ? this.state.configPay
                      : this.state.configPay
                  }
                  records={this.state.record_pay}
                  columns={this.state.columns_pay}
                  extraButtons={this.state.extraButtons}
                  dynamic={true}
                  total_record={this.state.total_record_pay}
                  onChange={this.tableChangeHandler}
                  onRowClicked={this.rowClickedHandlerPay}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete amenity popup modal */}
        <Modal
          show={this.state.saveModel}
          onHide={() => {
            if (window.confirm("Are you sure to save report?"))
              this.closeSaveModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeSaveModal()}
            >
              {global.closee}
            </span>
            <div className="text-center">
              <h3>Draft Report </h3>
              <p>Do you want to save report as Draft?</p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeSaveModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={(e) => this.saveOrUpdatePayout(e)}
                  disabled={this.state.isSave ? true : false}
                >
                  {this.state.isSave ? global.loader : "Save "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete amenity popup modal */}
        <Modal
          show={this.state.saveSendModel}
          onHide={() => {
            if (window.confirm("Are you sure to save report?"))
              this.closeSaveModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeSaveSendModal()}
            >
              {global.closee}
            </span>
            <div className="text-center">
              <h3>Finalize Payout</h3>
              <p>
                Do you really want to save the Report? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeSaveSendModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block button-width"
                  onClick={(e) => this.saveOrUpdatePayout(e)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Save & Send "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default GuestWavioTransfer;
